import React, { useContext, useEffect, useRef, useState } from "react";
import "./Style.css";
import "./InfluencerDashboard.css";
import './BusinessPages/Additional.css'
import PageName from "../Utils/PageName";
import axios from "axios";
import { userContext } from "../../context/userContext";
import { environmentVariables } from "../../config/env.config";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./Updatedcss/UpdatedDashboardstyle.css";
import { businessObjContext } from "../../context/businessObjContext";
import CircularLoader from "../Components/CircularLoader/CircularLoader";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import SortIcon from "@material-ui/icons/ArrowDownward";
import DataTable from "react-data-table-component";
import Dialog from '@mui/material/Dialog';
import TooltipImg from "./../../Images/info.png";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import { getCurrencyDataByCurrency, getUserPermission } from "../../utils/utility";

function WithdrawalRequests() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const { userData } = useContext(userContext);

  const [open, setOpen] = useState(false);
  const [storedData, setStoredData] = useState(
    localStorage.getItem("businessObj")
  );
  let buzzData = !!storedData ? JSON.parse(storedData) : "";
  let shipCountry = !!buzzData ? buzzData?.shipCountry : "";
  const httpProtocol = environmentVariables?.httpProtocol;
  const fronturl = environmentVariables?.frntUrl;
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const { businessObjData, setBusinessObjData } = useContext(businessObjContext);
  let busiObj = localStorage.getItem("businessObj");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [claimAmount, setClaimAmount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const tableExtensions = { export: false, print: false };
  const [GreatingMsg, setGreatingMsg] = useState("");
  const [openRemarks, setOpenRemarks] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState("");
  const [selectedDashDateFrom, setSelectedDashDateFrom] = useState("");
  const [selectedDashDateTo, setSelectedDashDateTo] = useState("");
  const [filter, setFilter] = useState(false);
  const [withdrawAmountLimit, setWithdrawAmountLimit] = useState(1000);
  const [totalPayin, setTotalPayin] = useState(0);
  const [totalPayout, setTotalPayout] = useState(0);
  const [totalClaimable, setTotalClaimable] = useState(0);
  const [totalSettlementFee, setTotalSettlementFee] = useState(0);
  const [totalSettlementtxn, setTotalSettlementtxn] = useState(0);
  const [totalPayintxn, setTotalPayintxn] = useState(0);
  const [totalPayoutFee, setTotalPayoutFee] = useState(0);
  const [totalPayouttxn, setTotalPayouttxn] = useState(0);
  const [customClaimAmount, setCustomClaimAmount] = useState(0);
  const [totalPayinwithoutFilter, setTotalPayinwithoutFilter] = useState(0);
  const [totalPayoutwithoutFilter, setTotalPayoutwithoutFilter] = useState(0);
  const [unsettledwithoutFilter, setUnsettledwithoutFilter] = useState(0);
  const [payoutPopup, setPayoutPopup] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [verifiedBanks, setVerifiedBanks] = useState([]);
  const [bankId, setBankId] = useState(0);
  const baseUrl = environmentVariables?.apiUrl;
  const initialValues = {
    bankId: 0,
    withrawAmount: null
  };

  let formik = useFormik({
    initialValues: initialValues,
    validationSchema: yup.object({
      bankId: yup
        .number()
        .required("Bank is required")
        .moreThan(0, "Please select a valid bank"),
      withrawAmount: yup
        .number()
        .required("Withdraw amount is required")
        .moreThan(0, "Withdraw amount must be greater than 0"),
    }),
    onSubmit: async (values) => {
      setIsSubmit(true);
      const payload = {
        "payout_method": "bank",
        "withdraw_amount": formik?.values?.withrawAmount,
        "bank_id": formik?.values?.bankId
      };


      try {
        const response = await axios.post(`${baseUrl}api/v1/custompayment/withdraw_request`, payload, {
          headers: {
            'Content-Type': 'application/json',
            _token: userData?.token,
          },
        });
        toast.success(response?.data?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        formik.resetForm();
        setIsSubmit(false);
        fetchWithdrawRequests(1);
        handlePayout();
      } catch (error) {
        console.error('Error ', error);
        toast.error(error?.response?.data?.message || error?.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        });
        setIsSubmit(false);
        handlePayout();
      }
    },
  });

  async function fetchConfig() {
    try {
      const response = await axios.get(
        `${baseUrl}api/v1/admin/setting/fetchConfig`,
        {
          params: {
            cnf_type: "Web",
            name:['withdraw_amount_limit']
          },
        }
        );
      if (response.status === 200) {
        setWithdrawAmountLimit(response?.data?.result?.withdraw_amount_limit);
      }
    } catch (error) {
      console.error({ "Error:": error, msg: "ErrorLanding" });
    }
  }


  useEffect(() => {
    getInfluencerDashboardData()
    fetchWithdrawRequests(1);
  }, [selectedDashDateFrom, selectedDashDateTo]);


  const getInfluencerDashboardData = () => {
    axios
      .get(`${baseUrl}api/v1/custompayment/getBusinessownerpaymentSummaryById`, {
        params: { id: userData?.id, from_date: selectedDashDateFrom, to_date: selectedDashDateTo, country: shipCountry },
        headers: {
          _token: userData?.token,
        },
      })
      .then((res) => {
        if (res?.status === 200) {
          console.log(res, "asjdhkjashkjhkjhkj")
          setTotalPayin(res?.data?.result?.consolidatedData?.payin_amount || 0);
          setTotalPayintxn(res?.data?.result?.consolidatedData?.payin_count || 0);
          let showPayout = Number(res?.data?.result?.consolidatedPayoutData?.payout_amount) - Number(res?.data?.result?.consolidatedPayoutData?.payout_fee);
          setTotalPayout(showPayout || 0);
          setTotalPayoutFee(res?.data?.result?.consolidatedPayoutData?.payout_fee || 0);
          setTotalPayouttxn(res?.data?.result?.consolidatedPayoutData?.payout_count || 0);
          let claimableData = res?.data?.result?.payinWalletData;
          setTotalClaimable(claimableData);
          setCustomClaimAmount(claimableData);
          setTotalSettlementFee(res?.data?.result?.consolidatedData?.settled_fee);
          setTotalSettlementtxn(res?.data?.result?.consolidatedData?.settled_count);
          setCurrencySymbol(res?.data?.result?.currency);
          setTotalPayinwithoutFilter(res?.data?.result?.payinWalletData || 0);
          let payoutData = res?.data?.result?.payoutWalletData || 0;
          setTotalPayoutwithoutFilter(payoutData);
          setUnsettledwithoutFilter(res?.data?.result?.unsettledAmountData || 0);
          let claimableAmount = res?.data?.result?.consolidatedData?.settled_amount - res?.data?.result?.consolidatedData?.settled_fee;
          setClaimAmount(claimableAmount)
        }
      })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          console.error("Resource not found:", error);
        } else {
          console.error("error:", error);
        }
      });
  };

  useEffect(() => {
    getInfluencerDashboardData();
  }, [storedData, busiObj]);

  const handleResetDash = () => {
    setSelectedDashDateFrom("");
    setSelectedDashDateTo("");
  };

  const fetchWithdrawRequests = async (page, size = perPage) => {
    try {
      axios
        .get(`${baseUrl}api/v1/custompayment/get_withdrawrequests?from_date=${selectedDashDateFrom}&to_date=${selectedDashDateTo}&page=${page}&limit=${size}`, {
          headers: {
            _token: userData?.token
          }
        })
        .then((response) => {
          console.log("response1111111", response);
          setData(response?.data?.mainData);
          setTotalRows(response.data.total);
          // setCurrentPage(response.data.currentPage);
          setIsLoading(false)
        })
        .catch((error) => {
          console.log(error);
          setIsLoading(false)
        });
    } catch (err) {
      setData([])
      setIsLoading(false)
    }
  };
  const fetVerifiedBanks = async (page, size = perPage) => {
    try {
      axios
        .get(`${baseUrl}api/v1/user/getVerifiedBankDetails`, {
          headers: {
            _token: userData?.token
          }
        })
        .then((response) => {
          console.log("banksres===>>>>", response);
          setVerifiedBanks(response?.data?.data);
        })
        .catch((error) => {
          console.log("error====>>>", error);
        });
    } catch (err) {
      console.log("erroror====>>>>", err);

    }
  };

  const handlePayout = () => {
    if (payoutPopup == true) {
      setPayoutPopup(!payoutPopup);
    } else {

      if (!verifiedBanks || verifiedBanks?.length < 1) {
        Swal.fire({
          title: 'Request Denied',
          text: "Please add bank details first!",
          icon: 'warning',
          confirmButtonColor: '#5c53e1',
          confirmButtonText: '<i class="fa-solid fa-plus"></i> Add Bank Details'
        }).then((result) => {
          if (result.isConfirmed) {
            navigate('/profile', {
              state: {
                activelink: "tab5"
              }
            });
          }
        });
      }
      else {
        ((totalPayoutwithoutFilter) === 0 || !!data && data?.length > 0 && data[0]?.payment_status == 'pending' || (totalPayoutwithoutFilter) < withdrawAmountLimit) ? setPayoutPopup(false) : setPayoutPopup(true);
      }
    }
  };



  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    fetchWithdrawRequests(1);
    fetVerifiedBanks();
    fetchConfig();
  }, [])

  const hideModal = () => {
    setOpenRemarks(false);
    setSelectedMessage("");
  };


  const handleViewMessage = (d) => {
    setOpenRemarks(true);
    setSelectedMessage(d);
  };


  function useWindowWidth() {
    const [width, setWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => setWidth(window.innerWidth);
      window.addEventListener("resize", handleResize);
      return () => window.removeEventListener("resize", handleResize);
    }, []);
    return width;
  }


  const windowWidth = useWindowWidth();

  const getStatusStyle = (status) => {
    const styles = {
      failed: { color: "#e71c1f", background: "#e71c1f33" },
      pending: { color: "#ffa401", background: "#ffa40133" },
      completed: { color: "#2892D5", background: "#2892D533" },
      settled: { color: "#26a56a", background: "#26a56a33" },
      transaction_not_paid_yet: { color: "#ff6600", background: "#ff660033" },
    };

    const { color = "#000", background = "#00000033" } = styles[status] || {};

    return {
      fontWeight: "500",
      color,
      background,
      borderRadius: "4px",
      padding: "2px 0px",
      textTransform: "capitalize",
      minWidth: "90px",
      maxWidth: "90px",
      display: "block",
      textAlign: "center",
    };
  };


  const columns = [
    {
      name: t("Withdraw_request"),
      selector: (row) => {
        const date = new Date(row.created_at);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleString('en-US', options);
      },
      cell: (row) => {
        const date = new Date(row.created_at);
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        return (
          <div className="custom-cell" data-column-name={t("Payment_request")}>
            {date.toLocaleString('en-US', options)}
          </div>
        );
      },
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Requested_amount"),
      selector: (row) => {
        const amount = row.amount ?? "--";
        if (currencySymbol === "AED") {
          return `${amount} ${currencySymbol}`;
        } else {
          return `${getCurrencyDataByCurrency(currencySymbol)}${amount}`;
        }
      },
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Requested_amount")}>
          {currencySymbol === "AED" ? row.amount + " " + currencySymbol : getCurrencyDataByCurrency(currencySymbol) + row.amount || "--"}
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("bank_details"),
      // selector: (row) =>
      //   row.withdraw_status == "cancelled" ? "Cancel" : row.withdraw_status,
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("bank_details")}>
          <span >{row?.bankdata?.bank_name}<strong>({row?.bankdata?.account_number})</strong></span>
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "300px" : "100%",
    },
    {
      name: t("Withdraw_status"),
      selector: (row) =>
        row.withdraw_status == "cancelled" ? "Cancel" : row.withdraw_status,
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Withdraw_status")}>
          <span style={getStatusStyle(row.withdraw_status)}> {row.withdraw_status == "cancelled" ? "Cancelled" : row.withdraw_status}</span>
        </div>
      ),
      sortable: true,
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
    {
      name: t("Remarks"),
      sortable: true,
      cell: (row) => (
        <div className="custom-cell" data-column-name={t("Remarks")}>
          {row.remarks ? (
            <i
              className="first fas fa-eye"
              onClick={() => handleViewMessage(row)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            ></i>
          ) : (
            "--"
          )}
        </div>
      ),
      minWidth: windowWidth > 768 ? "180px" : "100%",
    },
  ];


  const customStyles = {

    headRow: {
      style: {
        display: "flex",
        alignItems: "stretch",
        width: "100%",
        backgroundColor: "#E9E9E9",
        minHeight: "52px",
        borderRadius: "2px 2px 0px 0px",
        padding: "8px 25px",
        border: "none",

      },
    },
    headCells: {
      style: {
        color: "#525252",
        fontSize: "16px",
        minHeight: "52px",
        fontSize: "15px",

      },
    },
    rows: {
      style: {
        padding: "20px 25px",
        fontSize: "14px",
        textTransform: "capitalize",
        minHeight: "48px ",
      },
    },
    pagination: {
      style: {
        borderTop: windowWidth > 768 ? "1px solid #0000001f" : "0",
      },
    },
  };

  const tableData = {
    columns,
    data,
  };
  const paginationOptions = {
    rowsPerPageText: t("Rows_per_page"),
    rangeSeparatorText: t("Of"),
    selectAllRowsItem: false,
    // selectAllRowsItemText: t("All"),
  };

  const handlePageChange = (page) => {
    fetchWithdrawRequests(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    fetchWithdrawRequests(page, newPerPage);
  };

  const handleFilter = () => {
    setFilter(!filter)
  }

  const handleDateFilter = (date) => {
    if (
      date &&
      date.from instanceof Date &&
      !isNaN(date.from) &&
      date.to instanceof Date &&
      !isNaN(date.to)
    ) {
      const fromDate = date.from.getTime();
      const toDate = date.to.getTime();

      setSelectedDashDateFrom(fromDate);
      setSelectedDashDateTo(toDate);
    }
    if (date == 'reset') {
      handleResetDash();
    }
  }
 let userManagePermission = getUserPermission(userData, 167); 

  return (
    <>
      <PageName PageName="Withdrawal Requests" />
      <div className="row Greeting_total_wrapper" id="custom_table">
        <div className="col-md-12 walletDashboard" style={{ padding: "0" }}>
          <div className="main inf_dash walletMobileTable">
            <div className="upperFilter">
              <h3 className="payin-payout-request-heading">{t("withdraw_request_list")}</h3>
              <div className="Remainingclaimableamtdiv">
                <h4 className="Remainingclaimableamt" style={{ display: "flex", gap: "20px" }}>
                  <span className="claimbtnspan" onClick={()=> navigate('/profile', {
                    state: {
                      activelink: "tab5"
                    }
                  })}>
                    <button className="claimbtn" style={{ fontFamily: "Poppins", fontWeight: "400" }}><i class="fa-solid fa-plus"></i>&nbsp;&nbsp; {t("Add_bank_details")} </button>
                  </span>
                  {
                    (
                      (userData.created_by === 0) || 
                      (userData.created_by !== 0 && userManagePermission)
                    ) ? (
                      <span
                        className={
                          (totalPayoutwithoutFilter === 0 || 
                          (!!data && data.length > 0 && data[0]?.payment_status === 'pending') || 
                          (totalPayoutwithoutFilter < withdrawAmountLimit))
                            ? "disableclaimbtnspan"
                            : "claimbtnspan"
                        }
                        onClick={handlePayout}
                      >
                        <button className="claimbtn" style={{ fontFamily: "Poppins", fontWeight: "400" }}>
                          {t("Generate_withdraw_request")}&nbsp;&nbsp;
                          <i className="fa-solid fa-arrow-right"></i>
                        </button>
                      </span>
                    ) : null
                  }


                </h4>
              </div>
            </div>


            {isLoading ? (
              <CircularLoader size={40} />
            ) : (
              <DataTableExtensions
                {...tableData}
                filterPlaceholder="Search Coupon"
                customStyles={customStyles}
                {...tableExtensions}
                className="extensionscls"
              >
                <DataTable
                  columns={columns}
                  data={data}
                  noHeader
                  defaultSortField="id"
                  sortIcon={<SortIcon />}
                  defaultSortAsc={true}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationRowsPerPageOptions={[10, 15, 20, 25, 30]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  dense
                  progressPending={isLoading}
                  paginationComponentOptions={{
                    ...paginationOptions,
                  }}
                  customStyles={customStyles}
                  noDataComponent={<div style={{ padding: "24px" }}>{t("No_records_found")}</div>}
                />
              </DataTableExtensions>
            )}
          </div>
          <Modal
            aria-labelledby="modal-title"
            aria-describedby="modal-desc"
            open={openRemarks}
            onClose={() => hideModal()}
            // onClose={() => setOpen(false)}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          // style={{ outline: "none" }}
          // style={{overflow:"scroll", outline:"none"}}
          >
            <Sheet
              variant="outlined"
              sx={{
                maxWidth: 500,
                minWidth: 390,
                borderRadius: "md",
                boxShadow: "lg",
                maxHeight: 300, // Limit the height
                overflow: "auto", // Enable scrolling if content exceeds height
                p: 2, // Reduce padding
              }}
              className="Infproductdetails"
            >
              <ModalClose variant="plain" sx={{ m: 1 }} />
              <Typography
                component="h2"
                id="modal-title"
                level="h4"
                textColor="inherit"
                fontWeight="lg"
                mb={2}
                textAlign="center"
              >
                {t("Remarks")}
              </Typography>

              <div>
                <div>{selectedMessage?.remarks}</div>
              </div>
            </Sheet>
          </Modal>

          <Dialog
            open={payoutPopup}
            onClose={handlePayout}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            id="withdrawRequest"
          >
            <div className=" withdrawRequest">
              <h3>{t("Confirm_withdraw_request")}</h3>

              <div className="balanceAmount">
                <p>{t("Wallet_balance")}</p>
                {currencySymbol !== "AED" ? (
                  <h5>{getCurrencyDataByCurrency(currencySymbol)}{!!totalPayoutwithoutFilter ? Number(totalPayoutwithoutFilter)?.toFixed(2) : 0 || 0}</h5>
                ) : (
                  <h5>{!!totalPayoutwithoutFilter ? Number(totalPayoutwithoutFilter)?.toFixed(2) : 0 || 0} {currencySymbol}</h5>
                )}
              </div>
              <form id="bplanForm">
                <div className="balanceAmount">
                  <p>{t("Total_withdrawl_amount")} </p>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter withdrawal amount*"
                    name="withrawAmount"
                    min="0"
                    max={totalPayoutwithoutFilter}
                    value={formik?.values?.withrawAmount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.withrawAmount && formik.errors.withrawAmount ? (
                    <div style={{ color: "red" }}>
                      {formik.errors.withrawAmount}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>

                <div className="balanceAmount">
                  <p>Bank Details</p>
                  <select
                    className="form-control"
                    name="bankId"
                    value={formik?.values?.bankId}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="0"> {t("Select Bank")}</option>
                    {!!verifiedBanks && verifiedBanks?.length > 0 && verifiedBanks?.map((bank) => (
                      !!bank?.id &&
                      <option key={bank?.account_number} value={bank?.id}>
                        {bank?.bank_name + '(' + bank?.account_number + ')'}
                      </option>
                    ))}
                  </select>
                  {(formik.touched.bankId && formik.errors.bankId) && (
                    <div style={{ color: "red" }}>
                      {formik.errors.bankId}
                    </div>
                  )}
                </div>
                <button
                  type="button"
                  className="requestpayout"
                  aria-label="Close"
                  onClick={formik.handleSubmit}
                >
                  {isSubmit ? <CircularLoader size={20} /> : t("Request_for_withdraw")}
                </button>
                <div className="cancelWithdraw cursor-pointer" onClick={handlePayout}>{t("Cancel")}
                </div>
              </form>
            </div>
          </Dialog>
        </div>
      </div>
    </>
  );
}
export default WithdrawalRequests;
//1112